function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m440 0h-400c-22.082031.0273438-39.9726562 17.917969-40 40v256c.0273438 22.082031 17.917969 39.972656 40 40h150.9375l-6 48h-24.9375c-4.417969 0-8 3.582031-8 8v32c0 4.417969 3.582031 8 8 8h160c4.417969 0 8-3.582031 8-8v-32c0-4.417969-3.582031-8-8-8h-24.9375l-6-48h150.9375c22.082031-.027344 39.972656-17.917969 40-40v-256c-.027344-22.082031-17.917969-39.9726562-40-40zm-400 16h400c13.253906 0 24 10.746094 24 24v216h-448v-216c0-13.253906 10.746094-24 24-24zm272 400h-144v-16h144zm-33.0625-32h-77.875l6-48h65.875zm161.0625-64h-400c-13.253906 0-24-10.746094-24-24v-24h448v24c0 13.253906-10.746094 24-24 24zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m427.039062 288.640625c-2.980468-1.214844-6.402343-.558594-8.71875 1.679687-3.09375 3.15625-3.09375 8.203126 0 11.359376.378907.34375.78125.664062 1.199219.960937.445313.300781.929688.542969 1.441407.71875.453124.230469.9375.394531 1.4375.480469.53125.09375 1.066406.148437 1.601562.160156 3.25.019531 6.1875-1.929688 7.433594-4.933594 1.246094-3 .554687-6.457031-1.753906-8.746094-.777344-.707031-1.671876-1.273437-2.640626-1.679687zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m96 128h64c4.417969 0 8-3.582031 8-8v-44.6875l21.65625-21.65625-11.3125-11.3125-10.902344 10.902344c-1.132812-3.136719-4.105468-5.234375-7.441406-5.246094h-64c-4.417969 0-8 3.582031-8 8v64c0 4.417969 3.582031 8 8 8zm8-64h48v4.6875l-16 16-10.34375-10.34375-11.3125 11.3125 16 16c3.125 3.121094 8.1875 3.121094 11.3125 0l10.34375-10.34375v20.6875h-48zm0 0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m96 224h64c4.417969 0 8-3.582031 8-8v-44.6875l21.65625-21.65625-11.3125-11.3125-10.902344 10.902344c-1.132812-3.136719-4.105468-5.234375-7.441406-5.246094h-64c-4.417969 0-8 3.582031-8 8v64c0 4.417969 3.582031 8 8 8zm8-64h48v4.6875l-16 16-10.34375-10.34375-11.3125 11.3125 16 16c3.125 3.121094 8.1875 3.121094 11.3125 0l10.34375-10.34375v20.6875h-48zm0 0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m224 112h144v16h-144zm0 0"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m224 64h96v16h-96zm0 0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m224 208h144v16h-144zm0 0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m224 160h32v16h-32zm0 0"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m272 160h96v16h-96zm0 0"
});

var Svg1 = function Svg1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "0 -24 480 480",
    width: "480pt",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1.b1a688ea.svg";
export { ForwardRef as ReactComponent };